import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardMedia } from '@material-ui/core';
import { ActionTile } from '../../../ActionTile';
import { ImageDialog } from '../../../ImageDialog';
import { makeCss } from '../../../../../../knock-design-system';
import { IMAGE_DIALOG_TYPES } from '../../../constants';

export const LOGO_ACTION_TILE = {
  ACTION_TEXT: 'Upload Logo',
  SUBTEXT: 'SVG, PNG, JPG (max. 10MB)',
};

const useCss = makeCss({
  actionTile: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    height: '180px',
    width: '180px',
  },
  logoImage: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
});

const LogoActionTile = ({ logos, updateLogos }) => {
  const css = useCss();
  const [isOpen, setIsOpen] = useState(false);

  const closeDialog = () => setIsOpen(false);

  const [{ url: logoUrl } = {}] = logos || [];

  return (
    <React.Fragment>
      <ImageDialog
        closeDialog={closeDialog}
        images={logos || []}
        isOpen={isOpen}
        type={IMAGE_DIALOG_TYPES.LOGO}
        updateImages={updateLogos}
      />

      <ActionTile
        actionText={LOGO_ACTION_TILE.ACTION_TEXT}
        actionOnClick={() => setIsOpen(true)}
        css={css.actionTile}
        iconName="upload"
        subText={LOGO_ACTION_TILE.SUBTEXT}
      >
        {logoUrl && (
          <CardMedia
            css={css.logoImage}
            component="img"
            image={logoUrl}
            alt="Logo"
          />
        )}
      </ActionTile>
    </React.Fragment>
  );
};

LogoActionTile.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      clUrl: PropTypes.string,
      thumbUrl: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  updateLogos: PropTypes.func,
};

export default LogoActionTile;
